export default __webpack_public_path__ + "static/media/img7.45a706c5.jpg";